export default "__VITE_ASSET__DqP60voC__"